import { configureStore } from '@reduxjs/toolkit'
import { api } from './api'
import { authReducer } from './auth/auth.slice'
import { trucksReducer } from './trucks/trucks.slice'
import { commonReducer } from './common.slice'

export const store = configureStore({
	reducer: {
		[api.reducerPath]: api.reducer,
		auth: authReducer,
		trucks: trucksReducer,
		common: commonReducer,
	},
	middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(api.middleware),
	devTools: process.env.NODE_ENV === 'development',
})

export type RootState = ReturnType<typeof store.getState>
